import { createFileRoute } from "@tanstack/react-router";
import { comparisonRoute } from "@/lib/seo/comparisonRoute";
import { getComparison } from "@/lib/seo/comparisons";

export const Route = createFileRoute("/jamfor/kunskapsarv-internt-vs-extern-filmbyra")(
  comparisonRoute(getComparison("kunskapsarv-internt-vs-extern-filmbyra")),
);
